
export const JOB_TITLE_CHAR_LIMIT_ELLIPSIS = 50;